angular.module('client-group')
    .component('clientGroupList', {
        bindings: {
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/client-group/list.html',
        controller: function ($scope, $state, $stateParams, ClientGroup, ClientGroupService, ClientGroupConst) {
            this.reset = () => this.filters = {}
            this.ClientGroupService = ClientGroupService
            $scope.$on(ClientGroupConst.eventUpdate, () => $state.reload())
        }
    })
